(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2685,1501],{

/***/ 19148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CustomHead; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


function CustomHead(_ref) {
  var children = _ref.children,
      title = _ref.title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("title", {
      children: [title, " | ", "SUPERMARKET Κρητικός"]
    }), children]
  });
}

/***/ }),

/***/ 29962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83253);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_modal__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_modalStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13764);
/* harmony import */ var _Buttons_Buttons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3805);
/* harmony import */ var _GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61429);
/* harmony import */ var _GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var CUSTOM_STYLES_V2 = {
  overlay: _objectSpread({}, _utils_modalStyle__WEBPACK_IMPORTED_MODULE_3__/* ["default"].overlay */ .Z.overlay),
  content: _objectSpread(_objectSpread({}, _utils_modalStyle__WEBPACK_IMPORTED_MODULE_3__/* ["default"].content */ .Z.content), {}, {
    outline: '0'
  })
};

function GenericModalV2(_ref) {
  var children = _ref.children,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen,
      _ref$mainText = _ref.mainText,
      mainText = _ref$mainText === void 0 ? '' : _ref$mainText,
      modalLabel = _ref.modalLabel,
      onClickContinue = _ref.onClickContinue,
      _ref$submitText = _ref.submitText,
      submitText = _ref$submitText === void 0 ? 'Συνέχεια' : _ref$submitText;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(isOpen),
      _isModalOpen = _useState[0],
      setIsModalOpen = _useState[1];

  var _onClickContinue = onClickContinue || closeModal;

  function closeModal() {
    setIsModalOpen(false);
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((react_modal__WEBPACK_IMPORTED_MODULE_2___default()), {
    isOpen: _isModalOpen,
    style: CUSTOM_STYLES_V2,
    contentLabel: modalLabel,
    ariaHideApp: false,
    className: (_GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_6___default().modalContent),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
      className: (_GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_6___default().modalContainer),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("main", {
        children: children || /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          className: (_GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_6___default().text),
          children: mainText
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("footer", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_Buttons_Buttons__WEBPACK_IMPORTED_MODULE_4__/* .PrimaryButton */ .KM, {
          onClick: _onClickContinue,
          children: [" ", submitText]
        })
      })]
    })
  });
}

/* harmony default export */ __webpack_exports__["default"] = (GenericModalV2);

/***/ }),

/***/ 36593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PageTitle; }
/* harmony export */ });
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13282);
/* harmony import */ var _PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




function PageTitle(_ref) {
  var title = _ref.title,
      heading = _ref.heading;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("section", {
    className: (_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().section),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
      className: (_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().content),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
        className: (_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().title),
        children: title
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: (_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().breadcrumbs),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
          href: "/",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
            className: (_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().breadcrumbPrevious),
            children: "\u0391\u03C1\u03C7\u03B9\u03BA\u03AE"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
          className: (_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().breadcrumbSeparator),
          children: "/"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
          children: heading || title
        })]
      })]
    })
  });
}

/***/ }),

/***/ 6836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PageLayout; }
/* harmony export */ });
/* harmony import */ var _sentry_node__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39666);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Page_Title_PageTitle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36593);
/* harmony import */ var _generalLayout_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34746);
/* harmony import */ var _generalLayout_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_generalLayout_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _PageLayout_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10052);
/* harmony import */ var _PageLayout_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_PageLayout_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);









function PageLayout(_ref) {
  var _pageData$fields;

  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
  var pageData = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(data, 'data[0]');

  if (!pageData) {
    (0,_sentry_node__WEBPACK_IMPORTED_MODULE_4__/* .captureMessage */ .uT)("Invalid page data for ".concat(router.asPath));
    return null;
  }

  var sections = pageData === null || pageData === void 0 ? void 0 : (_pageData$fields = pageData.fields) === null || _pageData$fields === void 0 ? void 0 : _pageData$fields.sections;

  if (!pageData) {
    (0,_sentry_node__WEBPACK_IMPORTED_MODULE_4__/* .captureMessage */ .uT)("Invalid page sections for ".concat(router.asPath));
    return null;
  }

  var imgSrc = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(sections, '[0].image.path', '');
  var imgTitle = pageData.title || title || '';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_Page_Title_PageTitle__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      title: title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("section", {
      className: (_PageLayout_module_scss__WEBPACK_IMPORTED_MODULE_5___default().section),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: (_generalLayout_module_scss__WEBPACK_IMPORTED_MODULE_6___default().container),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
          className: (_generalLayout_module_scss__WEBPACK_IMPORTED_MODULE_6___default().row),
          children: [imgSrc && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
            className: (_PageLayout_module_scss__WEBPACK_IMPORTED_MODULE_5___default().imageContainer),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
              className: (_PageLayout_module_scss__WEBPACK_IMPORTED_MODULE_5___default().img),
              src: imgSrc,
              alt: imgTitle
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
            className: (_PageLayout_module_scss__WEBPACK_IMPORTED_MODULE_5___default().content),
            children: sections.map(function (_ref2) {
              var uuid = _ref2.uuid,
                  heading = _ref2.heading,
                  text = _ref2.text;
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("h2", {
                  className: (_PageLayout_module_scss__WEBPACK_IMPORTED_MODULE_5___default().sectionHeading),
                  dangerouslySetInnerHTML: {
                    __html: heading
                  }
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
                  className: (_PageLayout_module_scss__WEBPACK_IMPORTED_MODULE_5___default().sectionText),
                  dangerouslySetInnerHTML: {
                    __html: text
                  }
                })]
              }, uuid);
            })
          })]
        })
      })
    })]
  });
}

/***/ }),

/***/ 92893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ GiftCards; }
});

// EXTERNAL MODULE: ./styles/pages/index.module.scss
var index_module = __webpack_require__(28833);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/components/CustomHead.jsx
var CustomHead = __webpack_require__(19148);
// EXTERNAL MODULE: ./src/components/Footer/Footer.jsx + 5 modules
var Footer = __webpack_require__(31875);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/ThemeProvider/ThemeProvider.js + 3 modules
var ThemeProvider = __webpack_require__(72255);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 8 modules
var TextField = __webpack_require__(26);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./src/api/giftCard.js



function getGiftCardPoints(_x) {
  return _getGiftCardPoints.apply(this, arguments);
}

function _getGiftCardPoints() {
  _getGiftCardPoints = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(giftcardId) {
    var _yield$axios$get, data;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return axios_default().get("".concat("https://kritikos-cxm-production.herokuapp.com", "/api/v2/proxies/giftcard/").concat(giftcardId), {
              headers: {
                appId: "kritikos-web"
              }
            });

          case 3:
            _yield$axios$get = _context.sent;
            data = _yield$axios$get.data;
            return _context.abrupt("return", {
              data: data
            });

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", {
              error: _context.t0
            });

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));
  return _getGiftCardPoints.apply(this, arguments);
}
// EXTERNAL MODULE: ./src/store/loader.js
var loader = __webpack_require__(58766);
// EXTERNAL MODULE: ./src/utils/themeProvider.js
var themeProvider = __webpack_require__(65168);
// EXTERNAL MODULE: ./src/components/GenericModalV2.jsx
var GenericModalV2 = __webpack_require__(29962);
// EXTERNAL MODULE: ./src/components/GiftCardForm/GiftCardForm.module.scss
var GiftCardForm_module = __webpack_require__(86226);
var GiftCardForm_module_default = /*#__PURE__*/__webpack_require__.n(GiftCardForm_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/GiftCardForm/GiftCardForm.jsx



var _excluded = ["ref", "onChange"];


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













function GiftCardForm() {
  var _useState = (0,react.useState)(false),
      isModalOpen = _useState[0],
      setModalOpen = _useState[1];

  var _useState2 = (0,react.useState)(''),
      errorMsg = _useState2[0],
      setErrorMsg = _useState2[1];

  var _useState3 = (0,react.useState)(''),
      mainText = _useState3[0],
      setMainText = _useState3[1];

  var required = 'Αυτό το πεδίο είναι υποχρεωτικό';
  var cardPattern = "\u039C\u03B7 \u03AD\u03B3\u03BA\u03C5\u03C1\u03B7 \u03BA\u03AC\u03C1\u03C4\u03B1 ".concat("ΚΡΗΤΙΚΟΣ");
  var errorMessages = {
    card: {
      required: required,
      pattern: cardPattern
    }
  };

  var _useForm = (0,index_esm/* useForm */.cI)({
    mode: 'onBlur'
  }),
      handleSubmit = _useForm.handleSubmit,
      control = _useForm.control;

  function getPoints(_x) {
    return _getPoints.apply(this, arguments);
  }

  function _getPoints() {
    _getPoints = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_data) {
      var cardInput, newInput, _yield$getGiftCardPoi, data, error, successful, giftcardBalance;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              cardInput = _data.card.replace(/[^\d\s]/, '');
              loader/* default.addEvent */.Z.addEvent('GETTING_POINTS');
              newInput = cardInput.trim();
              _context.next = 5;
              return getGiftCardPoints(newInput);

            case 5:
              _yield$getGiftCardPoi = _context.sent;
              data = _yield$getGiftCardPoi.data;
              error = _yield$getGiftCardPoi.error;

              if (!error) {
                _context.next = 12;
                break;
              }

              setMainText('Κάτι πήγε στραβά. Παρακαλώ δοκιμάστε αργότερα');
              loader/* default.removeEvent */.Z.removeEvent('GETTING_POINTS');
              return _context.abrupt("return");

            case 12:
              successful = data.payload.successful;

              if (successful) {
                _context.next = 17;
                break;
              }

              setErrorMsg('Δεν υπάρχει διαθέσιμο ποσό προς εξαργύρωση  στην κάρτα σας.');
              loader/* default.removeEvent */.Z.removeEvent('GETTING_POINTS');
              return _context.abrupt("return");

            case 17:
              giftcardBalance = data.payload.giftcardBalance;
              setMainText("To \u03C5\u03C0\u03BF\u03BB\u03BF\u03B9\u03C0\u03BF \u03C4\u03B7\u03C2 \u03BA\u03B1\u03C1\u03C4\u03B1\u03C2 \u03C3\u03B1\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9: ".concat(giftcardBalance, " \u20AC."));
              setErrorMsg('');
              setModalOpen(true);
              loader/* default.removeEvent */.Z.removeEvent('GETTING_POINTS');

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _getPoints.apply(this, arguments);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
      action: "",
      method: "POST",
      className: (GiftCardForm_module_default()).form,
      onSubmit: handleSubmit(getPoints),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        className: (GiftCardForm_module_default()).text,
        children: ["\u039A\u03AC\u03C1\u03C4\u03B1 ", "ΚΡΗΤΙΚΟΣ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (GiftCardForm_module_default()).span,
          children: "*"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ThemeProvider/* default */.Z, {
        theme: themeProvider/* theme */.r,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
          control: control,
          name: "card",
          defaultValue: "",
          rules: {
            required: true
          },
          render: function render(_ref) {
            var _ref$field = _ref.field,
                ref = _ref$field.ref,
                onChange = _ref$field.onChange,
                field = (0,objectWithoutProperties/* default */.Z)(_ref$field, _excluded),
                error = _ref.fieldState.error;

            return /*#__PURE__*/(0,jsx_runtime.jsx)(TextField/* default */.Z, _objectSpread(_objectSpread({}, field), {}, {
              variant: "outlined",
              onChange: onChange,
              fullWidth: true,
              error: error !== undefined,
              helperText: error && errorMessages.card[error.type],
              className: (GiftCardForm_module_default()).formField,
              inputProps: {
                inputMode: 'numeric',
                pattern: '[0-9]*'
              }
            }));
          }
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (GiftCardForm_module_default()).btnContainer,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
          className: (GiftCardForm_module_default()).submitBTn,
          value: "\u0394\u03B5\u03AF\u03C4\u03B5 \u03C4\u03BF \u03C5\u03C0\u03CC\u03BB\u03BF\u03B9\u03C0\u03BF \u03C3\u03B1\u03C2!",
          type: "submit"
        })
      }), errorMsg && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (GiftCardForm_module_default()).errorMsg,
        children: errorMsg
      })]
    }), isModalOpen && /*#__PURE__*/(0,jsx_runtime.jsx)(GenericModalV2["default"], {
      mainText: mainText,
      isOpen: isModalOpen,
      onClickContinue: function onClickContinue() {
        return setModalOpen(false);
      },
      modalLabel: "Info modal"
    })]
  });
}
// EXTERNAL MODULE: ./src/components/Header/Header.jsx + 8 modules
var Header = __webpack_require__(3266);
// EXTERNAL MODULE: ./src/components/Navigation/Navigation.jsx
var Navigation = __webpack_require__(86894);
// EXTERNAL MODULE: ./src/components/PageLayout/PageLayout.jsx
var PageLayout = __webpack_require__(6836);
;// CONCATENATED MODULE: ./src/pages/giftcards.jsx










var __N_SSG = true;
function GiftCards(_ref) {
  var _data$data$;

  var data = _ref.data,
      footerLinks = _ref.footerLinks,
      navigation = _ref.navigation;
  var title = (_data$data$ = data.data[0]) === null || _data$data$ === void 0 ? void 0 : _data$data$.title;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("header", {
      className: (index_module_default()).headerContainer,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {
        navigation: navigation
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Navigation/* default */.Z, {
        navigation: navigation
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CustomHead/* default */.Z, {
      title: title
    }, "title"), /*#__PURE__*/(0,jsx_runtime.jsx)(PageLayout/* default */.Z, {
      title: title,
      data: data
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(GiftCardForm, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {
      footerLinks: footerLinks
    })]
  });
}

/***/ }),

/***/ 13764:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var CUSTOM_STYLES = {
  overlay: {
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 9,
    backgroundColor: 'rgba(0, 0, 0, 0.3)'
  },
  content: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate3d(-50%, -50%, 0)',
    padding: 0,
    right: 'unset',
    bottom: 'unset'
  }
};
/* harmony default export */ __webpack_exports__["Z"] = (CUSTOM_STYLES);

/***/ }),

/***/ 65168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ theme; }
/* harmony export */ });
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21265);
/* harmony import */ var _styles_layout_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65447);
/* harmony import */ var _styles_layout_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_styles_layout_module_scss__WEBPACK_IMPORTED_MODULE_1__);


var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
  typography: {
    fontFamily: _styles_layout_module_scss__WEBPACK_IMPORTED_MODULE_1__.brandFontFamily
  }
});

/***/ }),

/***/ 35506:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/giftcards",
      function () {
        return __webpack_require__(92893);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 61429:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"GenericModalV2_modalContainer__aCXv8","modalContent":"GenericModalV2_modalContent__Mpl98","text":"GenericModalV2_text__vXm9C","footer":"GenericModalV2_footer__YXTWC","btn":"GenericModalV2_btn__rhKmF"};

/***/ }),

/***/ 86226:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"GiftCardForm_form__MwQlf","text":"GiftCardForm_text__g0NRe","span":"GiftCardForm_span__l47wi","input":"GiftCardForm_input__cy6Gz","errorMessageForm":"GiftCardForm_errorMessageForm__Y9F6e","errorMsg":"GiftCardForm_errorMsg__kYryy","btnContainer":"GiftCardForm_btnContainer__2pO7N","submitBTn":"GiftCardForm_submitBTn__hW_uv"};

/***/ }),

/***/ 13282:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"PageTitle_section__JW_pb","content":"PageTitle_content__b6zB3","title":"PageTitle_title__MR_HW","breadcrumbs":"PageTitle_breadcrumbs__yPd2_","breadcrumbSeparator":"PageTitle_breadcrumbSeparator__bNku9","breadcrumbPrevious":"PageTitle_breadcrumbPrevious__o_DvH"};

/***/ }),

/***/ 10052:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"PageLayout_imageContainer__GRL8D","contentLayout":"PageLayout_contentLayout__gGWKB","section":"PageLayout_section__3ScLZ","sectionHeading":"PageLayout_sectionHeading__ONBWs","sectionText":"PageLayout_sectionText__1ZhLD","container":"PageLayout_container__WxJOb","asideContainer":"PageLayout_asideContainer__rgwza","img":"PageLayout_img__GGTjX","contentSize":"PageLayout_contentSize__NbSyS","content":"PageLayout_content__13aHA"};

/***/ }),

/***/ 34746:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"generalLayout_container__Y5Zwj","row":"generalLayout_row__Ckhzv"};

/***/ }),

/***/ 65447:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"brandFontFamily":"\"Roboto\",Helvetica,Arial,sans-serif","container":"layout_container__8mgcn","section":"layout_section__q1Enk","row":"layout_row___Mosi"};

/***/ }),

/***/ 28833:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"index_headerContainer__J9svF"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5937,9866,1228,4617,5445,3609,3253,3996,4843,9979,7536,9950,9774,2888,179], function() { return __webpack_exec__(16395), __webpack_exec__(35506); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);